import React, { useState, useEffect } from "react";

const WebsiteCookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("dojotrack_cookie_consent");
    if (!consent) {
      setVisible(true);
    }

    const openSettings = () => setVisible(true);
    window.addEventListener("dojotrack-open-cookie-settings", openSettings);
    return () => {
      window.removeEventListener("dojotrack-open-cookie-settings", openSettings);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem("dojotrack_cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[70] flex justify-center items-end pointer-events-none">
      <div className="pointer-events-auto m-4 p-4 bg-white border border-[#e3e8ee] rounded-2xl shadow-[0_10px_30px_rgba(16,36,63,0.06)] max-w-xl w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="text-[#4b5c73] text-sm">
          By using this website, you agree to our{" "}
          <a
            href="/privacy-policy"
            className="text-[#0d7c76] underline hover:text-[#0a635e]"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{" "}
          and{" "}
          <a
            href="/terms"
            className="text-[#0d7c76] underline hover:text-[#0a635e]"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          .
        </div>
        <button
          onClick={handleAccept}
          className="bg-[#10243f] text-white px-4 py-2 rounded-xl font-semibold hover:bg-[#0c1b30] transition"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default WebsiteCookieConsent;
